import { useState, useCallback } from 'react';
import { pluginApi } from '../../../utils/api';

export const usePluginSync = () => {
  const [syncStatus, setSyncStatus] = useState({
    isSyncing: false,
    lastSync: null,
    error: null,
    stats: null
  });

  const syncPlugins = useCallback(async () => {
    if (syncStatus.isSyncing) return;

    try {
      setSyncStatus(prev => ({
        ...prev,
        isSyncing: true,
        error: null
      }));

      const data = await pluginApi.sync();

      setSyncStatus({
        isSyncing: false,
        lastSync: data.timestamp,
        error: null,
        stats: {
          totalPlugins: data.stats?.total_plugins || 0,
          successfulSyncs: data.stats?.successful_syncs || 0,
          failedSyncs: data.stats?.failed_syncs || 0,
          duration: data.stats?.total_duration || '0s',
          volumeUsage: data.stats?.volume_usage || { total_space: '0GB', available_space: '0GB' }
        }
      });

      await pluginApi.list();
      return data;
    } catch (error) {
      console.error('Plugin sync failed:', error);
      
      setSyncStatus(prev => ({
        ...prev,
        isSyncing: false,
        error: error.message || 'An unknown error occurred during sync'
      }));

      throw error;
    }
  }, [syncStatus.isSyncing]);

  const getSyncStatusMessage = useCallback(() => {
    if (syncStatus.isSyncing) {
      return 'Syncing plugins...';
    }

    if (syncStatus.error) {
      return `Sync failed: ${syncStatus.error}`;
    }

    if (syncStatus.lastSync && syncStatus.stats) {
      const date = new Date(syncStatus.lastSync).toLocaleString();
      return `Last synced at ${date} (${syncStatus.stats.successfulSyncs}/${syncStatus.stats.totalPlugins} successful)`;
    }

    return 'Never synced';
  }, [syncStatus]);

  return {
    syncPlugins,
    syncStatus,
    getSyncStatusMessage,
    isLoading: syncStatus.isSyncing
  };
};